/* MARIE SOPHIE — Größenberater.
   Liest die Maßtabelle aus der Produktbeschreibung und rechnet daraus
   drei Empfehlungen: eng, normal, weit. Fallen zwei davon auf dieselbe
   Größe, werden sie zu einer Karte zusammengefasst. */
(function(){
  var openBtn = document.querySelector('[data-sza-open]');
  var box = document.querySelector('[data-sza]');
  if(!openBtn || !box || window.__szaInit) return;
  window.__szaInit = true;

  var ORDER = ['2XS','XS','S','M','L','XL','2XL','3XL','4XL'];
  var ALIAS = { 'XXS':'2XS','XXL':'2XL','XXXL':'3XL','XXXXL':'4XL' };
  /* Deutsche Konfektion -> Brustumfang in cm */
  var CONF = { 32:78, 34:82, 36:86, 38:90, 40:94, 42:98, 44:103, 46:108, 48:113 };
  /* Zugabe über dem Körpermaß je Sitz */
  var FITS = [
    { key:'eng',    title:'Eng',    ease:8,  note:'liegt an, wenig Platz für Strick' },
    { key:'normal', title:'Normal', ease:18, note:'normaler Sitz, Pullover passt drunter' },
    { key:'weit',   title:'Weit',   ease:30, note:'oversized, fällt locker' }
  ];

  function norm(t){
    var s = (t || '').toString().trim().toUpperCase().replace(/\s+/g,'');
    return ALIAS[s] || s;
  }
  /* ö und ß vereinheitlichen, damit "Größe", "Grösse" und "Grosse" gleich behandelt werden */
  function plain(t){
    return (t || '').toString().toLowerCase()
      .replace(/ß/g,'ss').replace(/ö/g,'o').replace(/ä/g,'a').replace(/ü/g,'u');
  }

  /* --- verfügbare Größen aus dem Kaufformular --- */
  function sizeInputs(){
    var fs = document.querySelectorAll('form[data-variants] fieldset.opt');
    for(var i=0;i<fs.length;i++){
      var lg = fs[i].querySelector('legend');
      if(lg && /grosse|size/.test(plain(lg.textContent))){
        return [].slice.call(fs[i].querySelectorAll('[data-opt]'));
      }
    }
    return [];
  }

  /* --- Maßtabelle aus der Beschreibung --- */
  function chart(){
    var tables = document.querySelectorAll('.acc__c table');
    for(var t=0;t<tables.length;t++){
      var ths = [].slice.call(tables[t].querySelectorAll('th'));
      var si = -1, ci = -1;
      ths.forEach(function(th,k){
        var s = plain(th.textContent);
        if(si < 0 && /grosse/.test(s)) si = k;
        if(ci < 0 && /brust/.test(s)) ci = k;
      });
      if(si < 0 || ci < 0) continue;
      var rows = [];
      [].slice.call(tables[t].querySelectorAll('tbody tr')).forEach(function(tr){
        var td = tr.querySelectorAll('td');
        if(td.length <= Math.max(si,ci)) return;
        var n = parseFloat(td[ci].textContent.replace(',','.').replace(/[^0-9.]/g,''));
        if(!isFinite(n)) return;
        rows.push({ key: norm(td[si].textContent), chest: n });
      });
      if(rows.length) return rows;
    }
    return null;
  }

  function letterFromBody(c){
    if(c <= 84) return 'XS';
    if(c <= 88) return 'S';
    if(c <= 95) return 'M';
    if(c <= 100) return 'L';
    if(c <= 105) return 'XL';
    return '2XL';
  }

  var opts = sizeInputs().map(function(i){ return { key: norm(i.value), value: i.value, input: i }; });
  var rows = chart();
  if(rows){
    var sellable = rows.filter(function(r){
      return !opts.length || opts.some(function(o){ return o.key === r.key; });
    });
    rows = sellable.length ? sellable : rows;
    rows.sort(function(a,b){ return a.chest - b.chest; });
  }

  function optFor(key){
    for(var i=0;i<opts.length;i++){ if(opts[i].key === key) return opts[i]; }
    return null;
  }

  function pickByChest(target){
    for(var i=0;i<rows.length;i++){ if(rows[i].chest >= target) return rows[i]; }
    return rows[rows.length - 1];
  }

  function pickByLetter(letter, shift){
    var list = opts.length ? opts.map(function(o){ return o.key; }) : ORDER.slice();
    list = list.slice().sort(function(a,b){ return ORDER.indexOf(a) - ORDER.indexOf(b); });
    var wanted = ORDER.indexOf(letter) + shift;
    var best = null, bestD = 99;
    list.forEach(function(k){
      var d = Math.abs(ORDER.indexOf(k) - wanted);
      if(d < bestD){ bestD = d; best = k; }
    });
    return best;
  }

  /* --- Fenster --- */
  function show(){ box.hidden = false; requestAnimationFrame(function(){ box.classList.add('is-on'); }); }
  function hide(){ box.classList.remove('is-on'); setTimeout(function(){ box.hidden = true; }, 340); }
  openBtn.addEventListener('click', show);
  box.addEventListener('click', function(e){ if(e.target.closest('[data-sza-close]')) hide(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !box.hidden) hide(); });

  var mode = 'chest';
  box.querySelectorAll('[data-sza-mode]').forEach(function(b){
    b.addEventListener('click', function(){
      mode = b.dataset.szaMode;
      box.querySelectorAll('[data-sza-mode]').forEach(function(x){ x.classList.toggle('is-on', x === b); });
      box.querySelectorAll('[data-sza-pane]').forEach(function(p){ p.hidden = p.dataset.szaPane !== mode; });
    });
  });

  var out = box.querySelector('[data-sza-out]');
  var cards = box.querySelector('[data-sza-cards]');
  var src = box.querySelector('[data-sza-src]');
  var err = box.querySelector('[data-sza-err]');

  function card(title, highlight, key, meta){
    var o = optFor(key);
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sza__c' + (highlight ? ' is-pick' : '');
    var sold = o && o.input.disabled;
    if(!o || sold) b.disabled = true;
    b.innerHTML = '<span class="sza__cs">' + (o ? o.value : key) + '</span>' +
                  '<span class="sza__cb"><span class="sza__ct">' + title + '</span>' +
                  '<span class="sza__cm">' + meta +
                  (sold ? ' · derzeit ausverkauft' : (!o ? ' · nicht im Sortiment' : '')) +
                  '</span></span>';
    if(o && !sold){
      b.addEventListener('click', function(){
        o.input.checked = true;
        o.input.dispatchEvent(new Event('change', { bubbles: true }));
        hide();
        var fsEl = o.input.closest('fieldset');
        if(fsEl && fsEl.scrollIntoView) fsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    return b;
  }

  /* gleiche Größe hintereinander zu einer Karte zusammenfassen */
  function group(picks){
    var gs = [];
    picks.forEach(function(p){
      var g = gs[gs.length - 1];
      if(g && g.key === p.key){ g.fits.push(p.fit); }
      else gs.push({ key: p.key, fits: [p.fit], meta: p.meta });
    });
    return gs;
  }

  function render(gs, note){
    cards.innerHTML = '';
    gs.forEach(function(g){
      var isNormal = g.fits.some(function(f){ return f.key === 'normal'; });
      var title = g.fits.length === 3
        ? 'Deine Größe'
        : g.fits.map(function(f){ return f.title; }).join(' und ');
      cards.appendChild(card(title, isNormal, g.key, g.meta));
    });
    src.textContent = note;
    out.hidden = false;
  }

  box.querySelector('[data-sza-go]').addEventListener('click', function(){
    var body;
    if(mode === 'chest'){
      body = parseFloat((box.querySelector('#sza-chest').value || '').replace(',','.'));
      if(!isFinite(body) || body < 60 || body > 160){
        err.textContent = 'Bitte einen Brustumfang zwischen 60 und 160 cm eintragen.';
        err.hidden = false; return;
      }
    } else {
      var c = box.querySelector('#sza-conf').value;
      if(!c){ err.textContent = 'Bitte eine Konfektionsgröße wählen.'; err.hidden = false; return; }
      body = CONF[c];
    }
    err.hidden = true;

    if(rows && rows.length){
      var gs = group(FITS.map(function(f){
        var r = pickByChest(body + f.ease);
        var ease = Math.round(r.chest - body);
        return { fit:f, key:r.key,
          meta:'Brustweite ' + r.chest + ' cm · ' + (ease >= 0 ? '+' : '') + ease + ' cm Spielraum' };
      }));
      var note = 'Gerechnet mit den Maßen aus der Beschreibung dieses Mantels: ' +
        rows.map(function(r){ return r.key + ' ' + r.chest + ' cm'; }).join(' · ') + '.';
      if(gs.length === 1){
        note += ' Dieser Schnitt ist so weit, dass für dein Maß in jeder Trageweise dieselbe Größe passt.';
      }
      render(gs, note);
    } else {
      var base = letterFromBody(body);
      var gs2 = group(FITS.map(function(f, i){
        var shift = i === 0 ? -1 : (i === 2 ? 1 : 0);
        return { fit:f, key:pickByLetter(base, shift), meta:f.note };
      }));
      if(gs2.length === 1) gs2[0].meta = 'passt dir in jeder Trageweise';
      render(gs2, 'Für dieses Modell sind keine Brustmaße angegeben – die Empfehlung geht deshalb von der üblichen Größenzuordnung aus.');
    }
  });
})();
